import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 房间合同账单
 */
import contractAdd from './add';
import houseContract from './houseContract';
import { fetchCreate, fetchUpdate, fetchChargeBill, fetchDetail } from '@/api/PMS/customerService/leaseContract/contractList';
export default {
  components: {
    contractAdd: contractAdd,
    houseContract: houseContract
  },
  props: {
    showDialog: Boolean,
    isUpdateContract: Boolean,
    // 是否是更改合同
    couldGenerateBill: Boolean,
    keyValue: {
      type: Number,
      default: -1
    },
    renewalId: {
      // 续签id
      type: [String || Number],
      default: ''
    },
    contractBaseData: {
      // 基础信息
      type: Object,
      default: function _default() {
        return {};
      }
    },
    clauseListData: {
      // 租赁条款
      type: Array,
      default: function _default() {
        return [];
      }
    },
    bondListData: {
      // 保证金条款
      type: Array,
      default: function _default() {
        return [];
      }
    },
    houseList: {
      // 租赁房间信息
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      baseData: {},
      baseInfoObj: {},
      houseBaseData: {},
      // 合同基本信息
      clauseList: [],
      // 租赁条款
      bondList: [],
      // 保证金条款
      houseListOption: [],
      triggerTime: 0,
      activeName: 'third',
      list: null,
      contractAddData: null,
      isGenerate: true,
      isAddContract: false,
      listLoading: false
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) this.init();
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      this.activeName = this.isUpdateContract ? 'first' : 'third';

      if (this.keyValue > 0) {
        this.handleConfirm(); // this.getDetail(this.keyValue)
      } else {
        // this.handleGenerateBill()
        this.handleConfirm();
      }
    },
    handleLeave: function handleLeave(activeName, oldActiveName) {
      var _this = this;

      var currentTime = new Date().getTime(); // 避免触发两次

      if (currentTime - this.triggerTime < 500 && oldActiveName === 'first' && activeName === 'second') {
        return Promise.reject();
      }

      if (currentTime - this.triggerTime < 500 && oldActiveName === 'second' && activeName === 'third') {
        return Promise.reject();
      }

      this.triggerTime = currentTime;
      var p = new Promise(function (resolve, reject) {
        if (oldActiveName === 'first' && activeName === 'second') {
          var isThrough = _this.$refs.baseInfo.handleNext();

          isThrough ? resolve() : reject();
        } else if (oldActiveName === 'second' && activeName === 'third') {
          var _isThrough = _this.$refs.contract.handleGeneratingBills();

          if (_isThrough) {
            _this.handleGenerateBill();

            resolve();
          } else {
            reject();
          }
        } else {
          resolve();
        }
      });
      return p;
    },
    handleClick: function handleClick(val) {
      if (val.paneName === 'first') {
        this.jumpToFrist();
      } else if (val.paneName === 'second') {
        this.jumpToSecond();
      } else {
        this.jumpToThird();
      }
    },
    jumpToFrist: function jumpToFrist() {
      this.activeName = 'first';

      if (this.keyValue < 0) {
        this.baseData = Object.keys(this.contractBaseData).length > 0 ? this.contractBaseData : {};
      } else {
        this.baseData = this.houseBaseData;
      }
    },
    jumpToSecond: function jumpToSecond() {
      this.activeName = 'second';

      if (this.keyValue < 0) {
        this.clauseList = this.clauseListData;
      }
    },
    jumpToThird: function jumpToThird(state) {
      this.activeName = 'third';
      if (state === 'generate') this.handleGenerateBill();
    },
    receiveAddData: function receiveAddData(obj) {
      this.houseListOption = obj.houseList;
      this.baseInfoObj = obj.childData;
    },
    getDetail: function getDetail(id) {
      var _this2 = this;

      this.listLoading = true;
      fetchDetail({
        id: id
      }).then(function (res) {
        if (res.data.code === 200) {
          var data = res.data.data;
          _this2.houseListOption = data.leaseContractResourceVos.map(function (item) {
            return {
              resourceCode: item.resourceCode,
              resourceId: item.resourceId
            };
          });
          _this2.list = data.chargeRecordUnsettleds;
          var childData = {
            leaseType: data.leaseType,
            areaGroupId: data.areaGroupId,
            customerId: data.customerId,
            contractNo: data.contractNo,
            contractName: data.contractName,
            beginDate: data.beginDate,
            endDate: data.endDate,
            remark: data.remark
          };
          _this2.baseInfoObj = childData;
          _this2.houseBaseData.childData = childData;
          _this2.areaGroupId = data.areaGroupId;
          _this2.houseBaseData.childData.areaGroupId = String(data.areaGroupId);
          _this2.houseBaseData.houseList = data.leaseContractResourceVos;
          _this2.baseData = _this2.houseBaseData;
          _this2.clauseList = data.leaseContractTeamsVos.filter(function (item) {
            return item.contractTeamsType === 1;
          });
          _this2.bondList = data.leaseContractTeamsVos.filter(function (item) {
            return item.contractTeamsType === 2;
          });

          _this2.clauseList.forEach(function (item, index) {
            _this2.$set(_this2.clauseList[index], 'chargeStandardId', item.leaseContractStandardVos[0].chargeStandardId);

            item.chargeMath = item.leaseContractStandardVos[0].chargeMath;
            item.chargePrice = item.leaseContractStandardVos[0].chargePrice;
            item.unitPrice = item.leaseContractStandardVos[0].unitPrice;
          });

          _this2.bondList.forEach(function (item, index) {
            _this2.$set(_this2.clauseList[index], 'chargeStandardId', item.leaseContractStandardVos[0].chargeStandardId);

            item.chargeMath = item.leaseContractStandardVos[0].chargeMath;
            item.chargePrice = item.leaseContractStandardVos[0].chargePrice;
            item.unitPrice = item.leaseContractStandardVos[0].unitPrice;
          });
        }

        _this2.listLoading = false;
      });
    },
    // 生成账单
    handleGenerateBill: function handleGenerateBill() {
      var _this3 = this;

      var customerId = '';
      var billList = [];

      if (this.keyValue > 0) {
        customerId = this.$refs.baseInfo.childData.customerId;
        this.clauseList = this.$refs.contract.clauseList;
        this.bondList = this.$refs.contract.bondList;
      } else {
        this.baseInfoObj = this.baseInfo;
        customerId = this.contractBaseData.childData.customerId;
        this.clauseList = this.clauseListData;
        this.bondList = this.bondListData;
        this.houseListOption = this.houseList;
      }

      this.clauseList.forEach(function (contract) {
        contract.leaseContractTeamsResourceVos.forEach(function (resourceId) {
          var billObj = {
            beginDate: contract.chargeBeginDate,
            endDate: contract.chargeEndDate,
            costBearers: contract.costBearers,
            resourceId: resourceId,
            customerId: customerId,
            chargeStandardId: contract.chargeStandardId,
            resourceType: 1
          };
          billList.push(billObj);
        });
      });
      this.bondList.forEach(function (contract) {
        contract.leaseContractTeamsResourceVos.forEach(function (resourceId) {
          var billObj = {
            beginDate: contract.chargeBeginDate,
            endDate: contract.chargeEndDate,
            costBearers: contract.costBearers,
            resourceId: resourceId,
            customerId: customerId,
            chargeStandardId: contract.chargeStandardId,
            resourceType: 1
          };
          billList.push(billObj);
        });
      });
      this.listLoading = true;
      fetchChargeBill(billList).then(function (res) {
        if (res.data.code === 200) {
          _this3.list = res.data.data;
        }

        _this3.listLoading = false;
      });
    },
    // 确认生成合同
    handleConfirm: function handleConfirm() {
      var _this4 = this;

      var baseData = {};
      var clauseList = []; // 租赁条款

      var bondList = []; // 保证金条款

      if (this.keyValue > 0) {
        // baseData = this.$refs.baseInfo
        // clauseList = this.$refs.contract.clauseList
        // bondList = this.$refs.contract.bondList
        baseData = this.contractBaseData;
        clauseList = this.clauseListData;
        bondList = this.bondListData;
      } else {
        baseData = this.contractBaseData;
        clauseList = this.clauseListData;
        bondList = this.bondListData;
      }

      clauseList.forEach(function (item) {
        item.contractTeamsType = 1;
      });
      bondList.forEach(function (item) {
        item.contractTeamsType = 1;
      });
      var addParams = baseData.childData;
      addParams.leaseContractResourceVos = baseData.houseList;
      var leaseContractTeamsVos = clauseList.concat(bondList);
      leaseContractTeamsVos.forEach(function (item) {
        item.leaseContractStandardVos = [{
          chargeStandardId: item.chargeStandardId,
          chargePrice: item.chargePrice
        }];
        item.leaseContractTeamsResourceVos = item.leaseContractTeamsResourceVos.map(function (resourceId) {
          return {
            resourceId: resourceId
          };
        });
      });
      addParams.leaseContractTeamsVos = leaseContractTeamsVos; // addParams.chargeRecordUnsettleds = this.list

      if (this.keyValue > 0 && !this.renewalId) {
        addParams.contractNo = this.keyValue;
        fetchUpdate(addParams).then(function (res) {
          if (res.data.code === 200) {
            _this4.Alert({
              alertType: 'update'
            });

            _this4.$emit('handCancle');
          }
        });
      } else if (this.renewalId) {
        addParams.upContractId = this.renewalId;
        fetchCreate(addParams).then(function (res) {
          if (res.data.code === 200) {
            _this4.Alert({
              alertType: 'add'
            });

            _this4.$emit('handCancle');
          }
        });
      } else {
        fetchCreate(addParams).then(function (res) {
          if (res.data.code === 200) {
            _this4.Alert({
              alertType: 'add'
            });

            _this4.$emit('handCancle');
          }
        });
      }
    },
    handlePrev: function handlePrev() {
      this.activeName = 'second';
    },
    handCancle: function handCancle(state) {
      this.$emit('handCancle');
    }
  }
};